import { Box } from "@mui/material";
import { ReactNode } from "react";
import Grid from "@mui/material/Grid2";
import { useSearch } from "./search-context";
import AdvancedSearchForm from "./advanced-search-form";
import { SearchFieldError, SearchFieldErrors } from "./types";
import FraudPreventionConsent from "./fraud-prevention-consent";
import QuickSearchForm from "./quick-search-form";
import HelperText from "./helper-text";

const SearchForm = ({
  isQuickSearch,
  fieldErrors,
  helperText,
  resetErrors,
  children,
}: {
  isQuickSearch: boolean;
  fieldErrors: SearchFieldErrors;
  helperText: SearchFieldError[];
  resetErrors: () => void;
  children: ReactNode;
}) => {
  const form = useSearch();

  return (
    <Box
      width="100%"
      sx={{
        backgroundColor: (theme) => theme.palette.background.default,
        flexGrow: 1,
        maxWidth: { sm: "90%", md: "1200px", lg: "1700px" },
        paddingBottom: 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          padding: (theme) => theme.spacing(4),
          borderRadius: 3,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 4px 20px rgba(0, 0, 0, 0.5)"
              : "0 4px 20px rgba(0, 0, 0, 0.08)",
        }}
      >
        {isQuickSearch ? (
          <QuickSearchForm errors={fieldErrors} resetErrors={resetErrors} />
        ) : (
          <AdvancedSearchForm resetErrors={resetErrors} />
        )}

        <FraudPreventionConsent defaultValue={form.fraudDtectionConsent} />

        <Grid
          size={{ xs: 12 }}
          alignItems="end"
          display="flex"
          justifyContent="flex-end"
        >
          <HelperText errors={helperText} />
        </Grid>
        {children}
      </Box>
    </Box>
  );
};

export default SearchForm;
